import { type Currency } from '@sequencehq/api'
import { GOCARDLESS_SUPPORTED_CURRENCIES } from '../../constants'

export const isGoCardlessSupportedCurrency = (currency: Currency): boolean => {
  return GOCARDLESS_SUPPORTED_CURRENCIES.includes(currency)
}
